import { Injectable, inject, computed } from '@angular/core';
import { AuthService } from '@com.maessa.payroll.frontend/auth';

@Injectable({ providedIn: 'root' })
export class SiteService {
  private readonly authService = inject(AuthService);

  readonly currentSiteId = computed(() => {
    const claims = this.authService.getClaimsFromToken();
    return claims?.site_id ?? null;
  });

  readonly currentUser = this.authService.currentUser;
}
